import React from "react";
import ReactDOM from "react-dom";
import "./OrganizationItemContextMenu.css";
import deleteIcon from "../../assets/delete.svg";
import ProfileTeamIcon from "../../assets/users.svg";
import renameIcon from "../../assets/edit.svg";
import LogoutIcon from "../../assets/logout.svg";

const OrganizationItemContextMenu = React.forwardRef(
  (
    {
      organization,
      onRename,
      onDelete,
      onLeave = () => {},
      onClose,
      style = {},
      className = "",
      onOpenTeamScreen = () => {},
      usePortal = false,
    },
    ref
  ) => {
    const menu = (
      <div
        className={`organization-item-context-menu ${className}`}
        style={style}
        ref={ref}
      >
        <div className="context-organization-item-list">
          {organization.isOwner && (
            <div
              className="context-organization-item-option"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onRename(e);
                onClose();
              }}
            >
              <img
                src={renameIcon}
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="context-organization-item-text">
                Переименовать
              </span>
            </div>
          )}
          {organization.isOwner && (
            <div
              className="context-organization-item-option"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onOpenTeamScreen(e);
                onClose();
              }}
            >
              <img
                src={ProfileTeamIcon}
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="context-organization-item-text">Команда</span>
            </div>
          )}
          {organization.isOwner && (
            <div
              className="context-organization-item-option"
              onClick={(e) => {
                onDelete(e);
                onClose();
              }}
            >
              <img
                src={deleteIcon}
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="context-organization-item-text">Удалить</span>
            </div>
          )}
          {!organization.isOwner && (
            <div
              className="context-organization-item-option"
              onClick={(e) => {
                onLeave(e);
                onClose();
              }}
            >
              <img
                src={LogoutIcon}
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="context-organization-item-text">Покинуть</span>
            </div>
          )}
        </div>
      </div>
    );
    if (usePortal) {
      return ReactDOM.createPortal(menu, document.body);
    }
    return menu;
  }
);

export default OrganizationItemContextMenu;
